import { gql } from "@apollo/client/core";

export const PRODUCT_LINE_STOCK_INFO = gql`
  query GetSkuGroup($distributorId: ID!, $stockLevelsInput: StockLevelsInput!) {
    getSkuGroup(distributorId: $distributorId, stockLevelsInput: $stockLevelsInput) {
      overallStockStatus
    }
  }
`;

export const dualProductQueryBuilder = dualProductAttributes => {
  let queryString = "";
  let queryParamString = "";
  for (let i = 0; i < dualProductAttributes.length; i++) {
    if (dualProductAttributes[i]) {
      const distributorParam = `distributorId${i}`;
      const stockLevelsInputParam = `stockLevelsInput${i}`;
      const subqueryName = `getSkuGroup${i}`;

      queryString += `
        ${subqueryName}: getSkuGroup(distributorId: $${distributorParam}, stockLevelsInput: $${stockLevelsInputParam}) {
          overallStockStatus
          numOptionsInStock
        }
      `;
      if (queryParamString.length > 0) {
        queryParamString += ", ";
      }
      queryParamString += `$${distributorParam}: ID!, $${stockLevelsInputParam}: StockLevelsInput!`;
    }
  }

  return gql`
    query GetSkuGroup (${queryParamString}) {
      ${queryString}
    }
`;
};
